export default __webpack_public_path__ + "static/media/x-android.5d1b24fad022cb73202bc60833748047.svg";